export class Branding {
    version?: string;
    siteName?: string;
    poweredBy?: string
    logoLightPath?: string
    logoFarkPath?: string
    faviconPath?: string
}

export const TenantTypes = [
    { value: "", label: "Select" },
    { value: "TRIAL", label: "TRIAL" },
    { value: "PROSPECT", label: "PROSPECT" },
    { value: "SUBSCRIBED", label: "SUBSCRIBED" },
];

export const SubcriptionStatuses = [
    { value: "", label: "Select" },
    { value: "PAYMENT_PENDING", label: "PAYMENT_PENDING" },
    { value: "PAID", label: "PAID" },
    { value: "ACTIVATED", label: "ACTIVATED" },
    { value: "DEACTIVATED", label: "DEACTIVATED" },
];


export const JobStatuses = [
    { value: "DRAFT", label: "DRAFT" },
    { value: "NEW", label: "NEW" },
    { value: "ONGOING", label: "ONGOING" },
    { value: "COMPLETED", label: "COMPLETED" },
    { value: "CANCELLED", label: "CANCELLED" },
    { value: "BLOCK", label: "BLOCK" },
];

